import { useCallback, useState } from 'react'
import { ModalSmallCentered, ButtonsModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import { CustomSelectWithSearchBar } from '../../../../../../../../forms/CustomSelect'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllWorkingCenters } from '../../../../../../../../utils/reducers/getters'

interface ModalWarehouseTPVProps extends ModalWarehouseTPVLogicProps {}

const ModalWarehouseTPV: React.FC<ModalWarehouseTPVProps> = ({ allRowData, setOpenModal, ...rest }) => {
    const { myWarehouseId, setMyWarehouseId, handleOnAccept, dictWarehouses } = useModalWarehouseTPVLogic({ setOpenModal, allRowData, ...rest })
    const { t } = useTwinTranslation()

    return (
        <ModalSmallCentered opened={true} setOpened={() => undefined} onClickOut={false} className='flex_height' >
            <h2>{t('chooseDefaultWarehouse', 'Debes escoger el almacén por defecto')}</h2>
            <span className='my-20 text-start'>{t('chooseWarehouseToProductWithNoWarehouse', 'Selecciona el almacén que quieres asignar a los productos con almacén no especificado')}</span>
            <div className='mt-10 mb-40'>
                <CustomSelectWithSearchBar className='w-200 m-auto' label={t('warehouse', 'Almacén')} items={dictWarehouses || {}} value={myWarehouseId || allRowData?.header?.WarehouseId} onChange={(value) => setMyWarehouseId(value)} />
            </div>
            <ButtonsModalSmallCentered setOpened={() => {}} onCancel={() => { setOpenModal(null) }} confirmText={t('accept', 'Aceptar')} onAccept={handleOnAccept} />
        </ModalSmallCentered>
    )
}

interface ModalWarehouseTPVLogicProps {
    setOpenModal: SetEditDeleteModalTy
    allRowData?: RowData
    handleOnAcceptFnc?: (allRowData: RowData) => void
}

const useModalWarehouseTPVLogic = ({ setOpenModal, allRowData, handleOnAcceptFnc }: ModalWarehouseTPVLogicProps) => {
    const workingCenters = getAllWorkingCenters()
    const dictWarehouses = workingCenters?.[allRowData?.cashRegister?.WorkingCenterId]?.dictWarehouses
    const [myWarehouseId, setMyWarehouseId] = useState<number | null>(workingCenters?.[allRowData?.cashRegister?.WorkingCenterId].warehouseMain || null)

    const handleOnAccept = useCallback(() => {
        if (!handleOnAcceptFnc) {
            setOpenModal({ type: 'create', allRowData: { ...allRowData, WarehouseId: myWarehouseId, type: 'PaymentMethods' } })
        } else {
            handleOnAcceptFnc?.({ ...allRowData, WarehouseId: myWarehouseId, type: 'PaymentMethods'})
        }
    }, [setOpenModal, myWarehouseId, allRowData, handleOnAcceptFnc])
    return { myWarehouseId, setMyWarehouseId, handleOnAccept, dictWarehouses }
}


export default ModalWarehouseTPV